// Compare only specific props between two objects.
export default function compareProps(object1, object2, propsToCompare) {
  let i = propsToCompare.length - 1;
  for (; i >= 0; i--) {
    if (object1[propsToCompare[i]] !== object2[propsToCompare[i]]) {
      return false;
    }
  }
  return true;
}
